module.exports = "/_next/static/images/40b0f849d682276ad98913472462a1a8-smartphone.svg.webp";